import ActionRequests from "components/actions-common/action-requests/action-requests";


export default function ActionRequestsIndex() {

    return (
        <ActionRequests />
    );
}